import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianNumberFormat'
})
export class IndianNumberFormatPipe implements PipeTransform {

  transform(value: number): any {
    if (!value)
      return 0;
    
    const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger values
    for (const suffix of suffixes) {
      if (Math.abs(value) < 1000) {
        return Math.floor(value) + suffix;
      }
      value /= 1000;
    }
    return Math.floor(value) + 'T';
  }

}
